module.exports = __webpack_public_path__ + "assets/img/ArtyWilmotte_cover.c5f69f2d-ps.jpg";